import styled from '@emotion/styled'
import { FlexDirectionProperty } from 'csstype'
import { calcRem } from '../../../__styling'

export interface RowButtonProps {
    flexDirection?: FlexDirectionProperty
    marginBottom?: number
}
const StyledButton = styled('div')<RowButtonProps>(
    ({ flexDirection = 'row', marginBottom = undefined }) => ({
        display: 'flex',
        flexDirection: flexDirection,
        marginBottom: marginBottom ? calcRem(marginBottom) : undefined,

        cursor: 'pointer',
    }),
)

StyledButton.displayName = 'StyledButton'
export default StyledButton
